(() => {
  const anchor = document.querySelector("[data-buy-anchor]");
  const bar = document.querySelector("[data-sticky-atc]");
  if (!anchor || !bar) return;
  const phone = matchMedia("(max-width: 989px)");
  new IntersectionObserver(([e]) => {
    // phones: whenever the main buy button is off-screen; desktop: only after scrolling past it
    const show = !e.isIntersecting && (phone.matches || e.boundingClientRect.top < 0);
    bar.toggleAttribute("data-visible", show);
    bar.inert = !show; // hidden bar stays out of tab order
  }).observe(anchor);
})();
